import React from "react";
import {Field} from "react-final-form";
import {Link} from "react-router-dom";
import styles from "./SeleccionarProceso.module.scss";
import {TiposIdentificacion, URLs} from "../../util/Constants";
import Dropdown from "../../components/UI/Dropdown/Dropdown";
import DropdownItem from "../../components/UI/DropdownItem/DropdownItem";
import TextField from "../../components/UI/TextField/TextField";
import Button from "../../components/UI/Button/Button";
import classNames from "classnames";
import imageGroup from "../../assets/img/group-3.svg";

const maxDocumentLength = 11;

const SeleccionarProcesoForm = (
  {
    tiposSolicitud,
    values,
    handleSubmit,
    loader,
    disabled
  }
) => {
  return (
    <div className={"row"}>
      <div className={"col-md-6 col-sm-12"}>

        <div className={styles.ColContainer}>

          <div className={styles.TitleContainer}>
            <h1 className={styles.Title}>Entrega de Documentos</h1>
            <p>Por favor, selecciona el proceso para el cual deseas aportar documentaci&oacute;n:</p>
          </div>

          <div className={classNames("d-md-none", styles.ImageContainer)}>
            <img id="spSeleccionarProcesoImg" src={imageGroup} alt={"Seleccionar Proceso"}/>
          </div>

          <form onSubmit={handleSubmit}>

            <Field
              component={Dropdown}
              id="spTipoProcesoFld"
              name="tipoProceso"
              labelText="Proceso">
              <DropdownItem value={""}>- Selecciona -</DropdownItem>
              {tiposSolicitud
                .map(tipoSolicitud =>
                  <DropdownItem key={tipoSolicitud.codigo}
                                value={tipoSolicitud.nombre}>
                    {tipoSolicitud.descripcion}
                  </DropdownItem>
                )}
            </Field>

            <Link id="spHelpLink"
                  to={URLs.SELECCIONAR_PROCESO_AYUDA}
                  className={styles.HelpLink}>
              No s&eacute; cu&aacute;l es el proceso que debo seleccionar
            </Link>

            {values.tipoProceso &&
            <>
              <Field
                component={Dropdown}
                id="spTipoIdentificacionFld"
                name="tipoIdentificacion"
                labelText="Tipo de documento del afiliado">
                <DropdownItem value={""}>- Selecciona -</DropdownItem>
                {TiposIdentificacion.map(tipoId =>
                  <DropdownItem
                    key={tipoId.id}
                    value={tipoId.id}>
                    {tipoId.descripcion}
                  </DropdownItem>
                )}
              </Field>

              <Field
                component={TextField}
                id="spNumeroIdentificacionFld"
                name="numeroIdentificacion"
                maxLength={maxDocumentLength}
                labelText="N&uacute;mero de documento del afiliado"
                valid={values.numeroIdentificacion && values.numeroIdentificacion.length <= maxDocumentLength}
              />
              {(values.numeroIdentificacion && (values.numeroIdentificacion.length > maxDocumentLength)) &&
              <span id="spNumeroIdentificacionSpan" className={styles.TextError}>
                    El N&uacute;mero de documento del afiliado no debe superar los 11 d&iacute;gitos.
              </span>
              }

              <Field
                component={TextField}
                id="spCodigoAsesoriaFld"
                name="codigoAsesoria"
                labelText="C&oacute;digo &uacute;nico de asesor&iacute;a"
                tooltip={<span id="spCodigoAsesoriaSpan" className={styles.text}>Podr&aacute;s
                  encontrar tu C&oacute;digo &Uacute;nico de asesor&iacute;a en la<br/> parte
                  superior derecha de tu lista documental.<br/>
                  <br/>

                  Si no tienes acceso a tu lista documental, puedes<br/>
                  llamar a la l&iacute;nea de servicio 75665993 o visitar la<br/>
                  Oficina de Servicio m&aacute;s cercana.</span>}
              >
                bolita
              </Field>

            </>
            }

            <div className={styles.SubmitButtonContainer}>
              <Button
                id="spIngresarBtn"
                name="spIngresarBtn"
                type="submit"
                typeStyle="primary"
                height={"40"}
                notFullWidth
                loader={loader}
                disabled={disabled}>
                Ingresar
              </Button>
            </div>

          </form>

        </div>

      </div>
      <div className={classNames("d-none d-md-block col-md-6", styles.BackgroundImage)}/>
    </div>
  );
};

export default SeleccionarProcesoForm;
